import feathersClient from "../../feathers-client";

const defaultApprovedReasonsConfigurationPagination = {
	total:100,
	$skip:0,
	$limit:10,
};
const defaultApprovedReasonsConfigurationPaginationFilter = {
	$skip:defaultApprovedReasonsConfigurationPagination.$skip,
	$limit: defaultApprovedReasonsConfigurationPagination.$limit
};

export default {
	state:{
		ApprovedReasonsConfiguration:[],
		ApprovedReasonsConfigurationPagination:defaultApprovedReasonsConfigurationPagination,
		ApprovedReasonsConfigurationPaginationFilter:defaultApprovedReasonsConfigurationPaginationFilter
	},
	getters:{
		setApprovedReasonsConfigurationPage:(state) => {
			const {$limit, $skip} = state.ApprovedReasonsConfigurationPagination;
			return $skip / $limit + 1;
		}

	},
	mutations:{
		SET_APPROVED_REASONS_CONFIGURATION:(state,data) => {state.ApprovedReasonsConfiguration = data;},
		SET_APPROVED_REASONS_CONFIGURATION_PAGINATION:(state, data) => {state.ApprovedReasonsConfigurationPagination = {...state.ApprovedReasonsConfigurationPagination, ...data};},
		SET_APPROVED_REASONS_CONFIGURATION_PAGINATION_FILTER:(state,data) => {state.ApprovedReasonsConfigurationPaginationFilter  = {...state.ApprovedReasonsConfigurationPaginationFilter, ...data};}

	},
	actions:{
		setApprovedReasonsConfigurationListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.ApprovedReasonsConfigurationPagination.$limit;
			commit('SET_APPROVED_REASONS_CONFIGURATION_PAGINATION', { $skip });
			commit('SET_APPROVED_REASONS_CONFIGURATION_PAGINATION_FILTER', { $skip });
		},

		getApprovedReasonsConfiguration: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/approve-reasons-configuration').find({
				query:{
					// $role: rootGetters.currentUserRole,
					...filter
				}
			});
			commit('SET_APPROVED_REASONS_CONFIGURATION',results.data);
			commit('SET_APPROVED_REASONS_CONFIGURATION_PAGINATION', {total :results.total})
			return results.data;
		},
		createApprovedReasonsConfiguration: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/approve-reasons-configuration').create(data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		updateApprovedReasonsConfiguration: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/approve-reasons-configuration').patch(data.id, data,{
				query:{
					$role: rootGetters.currentUserRole,
				}
			});
			return results;
		},
		deleteApprovedReasonsConfiguration: async ({rootGetters},id) => {
			const results = await feathersClient.service('/api/v3/approve-reasons-configuration').remove(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results;
		},
		getApprovedReasonsConfigurationById: async({rootGetters},id) =>{
			const results = await feathersClient.service('/api/v3/approve-reasons-configuration').get(id,{
				query:{
					// $role: rootGetters.currentUserRole,
				}
			});

			return results
		},
		getAllApprovedReasonsConfigurationForTrust: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/approve-reasons-configuration').find({
				query:{
					$role:rootGetters.currentUserRole,

				}
			});
			return results;
		},
		getAllApprovedReasonsConfiguration: async({rootGetters}) => {
			const results = await feathersClient.service('/api/v3/approve-reasons-configuration').find({
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results.data;
		}

	}
}
